import React, { useState } from "react";
import AsyncSelect from 'react-select/async';
import { Form } from "react-bootstrap";
import { getSelectGetDynamicData } from "../pages/generic/crud";
import {useThemeMode, systemMode} from "../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

export function AGCDynamicSelect({ entityId, formik, isMulti, name, toolTip, value, id, forUpdate = false, required = true, searchField = 'name', isClearable = undefined }) {
    const [inputValue, setInputValue] = useState('');
    const {mode} = useThemeMode();

    // Determine if dark mode is active
    const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark');

    // Custom styles for dark theme
    const customStyles = isDarkMode ? {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            borderColor: state.isFocused ? '#009ef7' : '#2b2b40',
            color: '#a1a5b7',
            '&:hover': {
                borderColor: '#009ef7'
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            border: '1px solid #2b2b40'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#2b2b40' : '#1e1e2d',
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#2b2b40'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        input: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c7293'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#2b2b40'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#3b3b54',
                color: '#ffffff'
            }
        })
    } : {};

    const loadOptions = (inputValue, callback) => {
        getSelectGetDynamicData(entityId, inputValue, searchField).then(({ data }) => {
            callback(data);
        }).catch(() => {
            callback([]);
        });
    };

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <AsyncSelect
                isMulti={isMulti}
                value={value}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                isClearable={isClearable !== undefined ? isClearable : !required}
                onChange={option => formik.setFieldValue(id, option)}
                styles={customStyles}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
